import React from 'react';
import { Typography } from '@mui/material';
import { formatTimeslotRangeKo } from '@/shared/lib/timeslot/timeslot.types';
import type { Timeslot } from '@/shared/lib/timeslot/timeslot.types';
import { fontSize, typography } from '@/shared/theme';

interface TimeslotSpanProps {
  raw: string;
}

export function TimeslotSpan({ raw }: TimeslotSpanProps) {
  try {
    const formatted = formatTimeslotRangeKo(raw as Timeslot);
    return (
      <Typography
        component="span"
        sx={{
          fontSize: fontSize.sm,
          fontWeight: typography.cell.fontWeight,
          color: 'text.primary',
        }}
      >
        {formatted}
      </Typography>
    );
  } catch {
    return (
      <Typography
        component="span"
        sx={{
          fontSize: fontSize.sm,
          color: 'text.secondary',
        }}
      >
        {raw}
      </Typography>
    );
  }
}
